import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Backend from "../utils/Backend";

import StatsCard from "./components/stats-cards/StatsCard";
import BasketsTable from "./components/tables/baskets/BasketsTable";

class ManageBaskets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    this._getStats();
  }

  _getStats() {
    this.setState({ isLoading: true });

    Backend.getBasketsStats()
      .then((stats) => {
        this.setState({ stats, isLoading: false });
      })
      .catch((error) => {
        // If stats endpoint doesn't exist yet, use default stats
        this.setState({
          stats: {
            total_baskets: 0,
            active_baskets: 0,
            hampers: 0,
            party_baskets: 0,
          },
          isLoading: false,
        });
      });
  }

  _goToAddBasket = () => {
    this.props.history.push("/manage-baskets/add-basket");
  };

  render() {
    const { stats } = this.state;

    return (
      <div className="container">
        {/* Stats Cards Row */}
        <div className="row wd-100 mb-5">
          <div className="col-lg-3 col-md-6 mb-4">
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.total_baskets || 0}`,
                  title: "Total Baskets",
                  icon: (
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M5,5 L5,19 C5,19.5523 5.4477,20 6,20 L18,20 C18.5523,20 19,19.5523 19,19 L19,5 C19,4.4477 18.5523,4 18,4 L6,4 C5.4477,4 5,4.4477 5,5 Z M9,8 L15,8 M9,12 L15,12 M9,16 L12,16"
                        fill="#FF5E8A"
                        opacity="0.8"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.active_baskets || 0}`,
                  title: "Active Baskets",
                  icon: (
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <rect x={0} y={0} width={24} height={24} />
                      <circle fill="#28a745" opacity="0.8" cx={12} cy={12} r={8} />
                      <path
                        d="M9,12 L11,14 L15,10"
                        stroke="#FFFFFF"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.hampers || 0}`,
                  title: "Hampers",
                  icon: (
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M4,9 L20,9 L19,19 C19,19.5523 18.5523,20 18,20 L6,20 C5.4477,20 5,19.5523 5,19 L4,9 Z"
                        fill="#FF5E8A"
                        opacity="0.8"
                      />
                      <path
                        d="M8,9 L8,7 C8,4.79086 9.79086,3 12,3 C14.2091,3 16,4.79086 16,7 L16,9"
                        stroke="#FF5E8A"
                        strokeWidth={2}
                        fill="none"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
          <div className="col-lg-3 col-md-6 mb-4">
            <StatsCard
              data={[
                {
                  statsInfo: `${stats?.party_baskets || 0}`,
                  title: "Party Baskets",
                  icon: (
                    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                      <rect x={0} y={0} width={24} height={24} />
                      <path
                        d="M12,3 L14,9 L20,9 L15,13 L17,20 L12,16 L7,20 L9,13 L4,9 L10,9 Z"
                        fill="#FF5E8A"
                        opacity="0.8"
                      />
                    </g>
                  ),
                },
              ]}
            />
          </div>
        </div>

        {/* Action Button */}
        <div className="row mb-5">
          <div className="col-12">
            <button
              type="button"
              className="btn btn-primary font-weight-bolder"
              onClick={this._goToAddBasket}
            >
              <span className="svg-icon svg-icon-md">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                    <rect fill="#FFFFFF" x={4} y={11} width={16} height={2} rx={1} />
                    <rect
                      fill="#FFFFFF"
                      opacity="0.3"
                      transform="translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000)"
                      x={4}
                      y={11}
                      width={16}
                      height={2}
                      rx={1}
                    />
                  </g>
                </svg>
              </span>
              Create New Basket
            </button>
          </div>
        </div>

        {/* Baskets Table */}
        <div className="row">
          <div className="col-12">
            <BasketsTable />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ManageBaskets);
